module.exports = __webpack_public_path__ + "img/customer-bg2.ee783830.jpg";